import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const GoogleLogo: React.FC<SvgProps> = (props) => {
    return (
        <Svg width={40} height={40} viewBox="-0.15 0 13.1 13.1" {...props}>
            <Path
                d="M12.794 6.673c0-.537-.044-.928-.138-1.335H6.528V7.76h3.597c-.072.602-.464 1.509-1.335 2.118l-.012.081 1.938 1.501.134.013c1.233-1.139 1.944-2.814 1.944-4.801"
                fill="#4285F4"
            />
            <Path
                d="M6.528 13.055c1.762 0 3.242-.58 4.323-1.581l-2.06-1.596c-.551.384-1.291.653-2.263.653-1.726 0-3.191-1.139-3.713-2.713l-.077.007L.723 9.384l-.026.073a6.52 6.52 0 005.831 3.598"
                fill="#34A853"
            />
            <Path
                d="M2.814 7.819a4 4 0 01-.218-1.291c0-.45.08-.885.21-1.291l-.004-.087L.763 3.566l-.067.032C.254 4.482 0 5.476 0 6.528s.254 2.045.696 2.93z"
                fill="#FBBC05"
            />
            <Path
                d="M6.528 2.524c1.226 0 2.052.529 2.524.972l1.842-1.799C9.762.646 8.29 0 6.528 0A6.52 6.52 0 00.696 3.597l2.111 1.639c.529-1.574 1.995-2.713 3.721-2.713"
                fill="#EB4335"
            />
        </Svg>
    );
};

export default React.memo(GoogleLogo);
